import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("  {{#if this.isResizable}}\n    <div class=\"et-header-resize-area\">\n    </div>\n  {{/if}}", {
  moduleName: "ember-table/components/ember-th/resize-handle/template.hbs"
});